module.exports = __webpack_public_path__ + "static/img/RAZ-S_1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/produkty/RAZ-S_1.png
// module id = 7bfN
// module chunks = 0